import i18n from "i18next"
import {initReactI18next} from "react-i18next"
import enJson from "../locales/en.json"
import jaJson from "../locales/ja.json"

i18n.use(initReactI18next).init({
  debug: true,
  initImmediate: false,
  preload: [`en`, `ja`],
  fallbackLng: `en`,
  lng: `en`,
  resources: {
    en: {
      translation: enJson,
    },
    ja: {
      translation: jaJson,
    },
  },
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
